import React, { useEffect, useState } from "react"
import * as AppConstants from "../../../utility/AppConstants"
import TabTotali from "./TabTotali"
import TabPersoneFisiche from "./TabPersoneFisiche"
import TabSocietaPersone from "./TabSocietaPersone"
import TabSocCapitaliEntiNonCommerciali from "./TabSocCapitaliEntiNonCommerciali"
import TabMacroareeTerritoriali from "./TabMacroareeTerritoriali"

import TabGrafici from "./TabGrafici"
import * as Utility from "../../../utility/Utility"
import { Tabs } from "@sogei/react-web-components-catalog"
function TabNazionali(props: any) {
    const items = [
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_TOTALI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabTotali
                    codIsa={props.codIsa}
                    macroarea={props.macroarea}
                    totale={props.datiNazionali.totale}
                    totalePersoneFisiche={
                        props.datiNazionali.totalePersoneFisiche
                    }
                    totaleSocietaPersone={
                        props.datiNazionali.totaleSocietaPersone
                    }
                    totaleSocCapitaliEntiNonComm={
                        props.datiNazionali.totaleSocCapitaliEntiNonComm
                    }
                    datiNazionali={props.datiNazionali}
                    macroareeTerritoriali={props.macroareeTerritoriali}
                    anno={props.anno}
                />
            )
        }
    ]

    if (
        props.codIsa === null ||
        props.codIsa === undefined ||
        props.codIsa.length === 0
    ) {
        items.push(
            {
                title: (
                    <>
                        <i className="fab fa-font-awesome-flag mr-2"></i>
                        {AppConstants.TAB_PERSONE_FISICHE}
                    </>
                ),
                titleHeading: "h1",
                body: (
                    <TabPersoneFisiche
                        codIsa={props.codIsa}
                        macroarea={props.macroarea}
                        totalePersoneFisiche={
                            props.datiNazionali.totalePersoneFisiche
                        }
                        personeFisicheRe={props.datiNazionali.personeFisicheRe}
                        personeFisicheRg={props.datiNazionali.personeFisicheRg}
                        personeFisicheRf={props.datiNazionali.personeFisicheRf}
                        datiNazionali={props.datiNazionali}
                        anno={props.anno}
                    />
                )
            },
            {
                title: (
                    <>
                        <i className="fab fa-font-awesome-flag mr-2"></i>
                        {AppConstants.TAB_SOCIETA_PERSONE}
                    </>
                ),
                titleHeading: "h1",
                body: (
                    <TabSocietaPersone
                        codIsa={props.codIsa}
                        macroarea={props.macroarea}
                        totaleSocietaPersone={
                            props.datiNazionali.totaleSocietaPersone
                        }
                        societaPersoneRe={props.datiNazionali.societaPersoneRe}
                        societaPersoneRg={props.datiNazionali.societaPersoneRg}
                        societaPersoneRf={props.datiNazionali.societaPersoneRf}
                        datiNazionali={props.datiNazionali}
                        anno={props.anno}
                    />
                )
            },
            {
                title: (
                    <>
                        <i className="fab fa-font-awesome-flag mr-2"></i>
                        {AppConstants.TAB_SOC_CAPITALI_ENTI_COMMERCIALI}
                    </>
                ),
                titleHeading: "h1",
                body: (
                    <TabSocCapitaliEntiNonCommerciali
                        codIsa={props.codIsa}
                        macroarea={props.macroarea}
                        totaleSocCapitaliEntiNonComm={
                            props.datiNazionali.totaleSocCapitaliEntiNonComm
                        }
                        socCapitaliEntiNonCommRe={
                            props.datiNazionali.socCapitaliEntiNonCommRe
                        }
                        socCapitaliEntiNonCommRg={
                            props.datiNazionali.socCapitaliEntiNonCommRg
                        }
                        socCapitaliEntiNonCommRf={
                            props.datiNazionali.socCapitaliEntiNonCommRf
                        }
                        datiNazionali={props.datiNazionali}
                        anno={props.anno}
                    />
                )
            }
        )
    }
    if (
        props.codIsa !== null &&
        props.codIsa !== undefined &&
        props.codIsa.length > 0 &&
        props.macroareeTerritoriali !== null &&
        props.macroareeTerritoriali.listaMob.length > 0
    ) {
        items.push({
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_MACROAREE_TERRITORIALI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabMacroareeTerritoriali
                    codIsa={props.codIsa}
                    macroarea={props.macroarea}
                    totalePersoneFisiche={
                        props.datiNazionali.totalePersoneFisiche
                    }
                    personeFisicheRe={props.datiNazionali.personeFisicheRe}
                    personeFisicheRg={props.datiNazionali.personeFisicheRg}
                    personeFisicheRf={props.datiNazionali.personeFisicheRf}
                    datiNazionali={props.datiNazionali}
                    macroareeTerritoriali={props.macroareeTerritoriali}
                    anno={props.anno}
                />
            )
        })
    }
    items.push({
        title: (
            <>
                <i className="fab fa-font-awesome-flag mr-2"></i>
                {AppConstants.TAB_GRAFICI}
            </>
        ),
        titleHeading: "h1",
        body: (
            <TabGrafici
                codIsa={props.codIsa}
                macroarea={props.macroarea}
                macroareasigla={Utility.trascodificaMacroArea(props.macroarea)}
                datiNazionali={props.datiNazionali}
                anno={props.anno}
            />
        )
    })

    return (
        <div className="row">
            <div className="col-12">
                <Tabs
                    items={items}
                    isReverseType={true}
                    //onShow={(e: any) => console.log(e)}
                />
            </div>
        </div>
    )
}

export default TabNazionali
